"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SortButton_meta_1 = require("../SortButton.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', SortButton_meta_1.SORT_BUTTON_CATEGORY_KEY, SortButton_meta_1.SORT_BUTTON_COMPONENT_KEY, ['wrapper']);